export default __webpack_public_path__ + "static/media/BLOOD_official.363bea64.png";